import React, { Fragment, useState, useEffect } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import { BoldText } from '../common/Card';
import TextBox, { TextArea } from 'components/ui/TextBox';
import { Select } from 'components/ui/Select/Select';

const FullWidthText = styled(TextBox)`
  margin: 10px 0px;
  width: 100%;
`;

// const StyledCloseButton = styled.div`
//   font-weight: bold;
//   cursor: pointer;
//   top: 1rem;
//   right: 2rem;
//   font-size: 1.2rem;
// `;

const StyledLabel = styled.label`
  display: block;
`;

const LeaseDocumentTypesGroup = ({ data, values, setValues }) => {
  const { label, type, fields, maxCount } = data;
  const [num, setNum] = useState(get(values, `lease_document_types[${type}].length`, 1));
  // const canAddMore = maxCount === -1 ? num < 100 : num < maxCount;

  useEffect(
    () => {
      if (maxCount === 1) {
        setNum(maxCount);
      }
    },
    [maxCount, setNum]
  );

  // ToDo: add both functionality of these functions below
  // const handleAddMoreClick = () => {
  //     setValues({
  //       ...values,
  //       [type]: [...values[type], {}],
  //     });
  //     setNum(num + 1);
  //   };

  // const removeValues = i => {
  //     const leaseDocValues = [...values[type]];
  //     leaseDocValues.splice(i, 1);
  //     setValues({
  //       ...values,
  //       [type]: leaseDocValues,
  //     });
  //     setNum(num - 1);
  // };

  const handleChange = (e, i, j) => {
    setValues(`lease_documents[${type}][${i}][${e.target.name}]`, e.target.value);
  };

  return (
    <Fragment>
      <BoldText>{label}</BoldText>
      {new Array(num).fill().map((_, i) => {
        return (
          <Fragment>
            {/* ToDo: fix close styleing and functionality */}
            {/* <StyledCloseButton onClick={() => removeValues(i)}>x</StyledCloseButton> */}
            {fields.map((data, j, required) => {
              const { tag, type, name, label, options = [], dynamicOptions } = data;
              return (
                <Fragment>
                  <StyledLabel key={`document-${type}-${i}-${name}-${j}`}>
                    {label}
                    {tag === 'input' && (
                      <FullWidthText
                        key={`${type}-`}
                        size="large"
                        name={name}
                        required={required === 'true'}
                        onChange={e => handleChange(e, i, j)}
                      />
                    )}
                    {tag === 'textarea' && (
                      <TextArea
                        name={name}
                        onChange={e => handleChange(e, i, j)}
                        required={required === 'true'}
                      />
                    )}
                    {tag === 'select' && (
                      <Select
                        name={name}
                        required
                        onChange={e => handleChange(e, i, j)}
                        options={[
                          { label: 'choose', value: '' },
                          ...options,
                          ...(dynamicOptions || []),
                        ]}
                        value={get(values, `[${i}].${name}`)}
                      />
                    )}
                  </StyledLabel>
                </Fragment>
              );
            })}
            {/* ToDo: add addmore functionality */}
            {/* {canAddMore && (
                        <CtaText type="button" onClick={handleAddMoreClick}>
                            add more
                        </CtaText>
                    )} */}
          </Fragment>
        );
      })}
    </Fragment>
  );
};

export default LeaseDocumentTypesGroup;
